import React from "react";
import PropTypes from "prop-types";
import { isRadioQuestion } from "./helpers";
import { sortAnswers } from "../../pages/helpers";
import { useAssumptionQuestions } from "./useAssumptionQuestions";
import {
  ComponentType,
  questionPresentationContent
} from "../../data/QuestionPresentation";
import { AssumptionsRadioAndCheckboxQuestion } from "./AssumptionsRadioAndCheckboxQuestion";

export default function AssumptionQuestions({
  questions,
  handleChange,
  handleCheckboxChange,
  selectedQuestionsHaveChanged,
  checkboxState
}) {
  const { questionHasChanged, questionsAndAnswers, isQuestionDisabled } =
    useAssumptionQuestions();
  const changedQuestionsKeys = Object.keys(selectedQuestionsHaveChanged);

  return (
    <div>
      {questions.map((question) => {
        let disabled = isQuestionDisabled(question);
        let sortedAnswers = sortAnswers(question.answers);

        if (isRadioQuestion(question)) {
          return (
            <div
              className="ch-form__group ch-mb--4 radio-question-assumptions"
              key={question.id}
            >
              <label
                htmlFor={question.id}
                className="ch-form__control-label ch-text--bold ch-display--block"
              >
                {question.content}
              </label>
              {sortedAnswers.map((answer) => {
                const checked = questionHasChanged(
                  question,
                  changedQuestionsKeys
                )
                  ? selectedQuestionsHaveChanged[question.id][0] === answer.id
                  : questionsAndAnswers[question.id][0] === answer.id;
                return (
                  <React.Fragment key={answer.id}>
                    <input
                      id={`${answer.id} - ${answer.label}`}
                      type="radio"
                      name={answer.id}
                      value={answer.id}
                      className="ch-reader ch-radio ch-mr--2"
                      checked={checked}
                      onChange={({ target: { value } }) => {
                        handleChange(question.id, parseInt(value));
                      }}
                      data-testid={question.id}
                    />
                    <label
                      htmlFor={`${answer.id} - ${answer.label}`}
                      className="ch-radio__label ch-radio__label--compact ch-mr--2 assumption-radio"
                    >
                      {answer.label}
                    </label>
                  </React.Fragment>
                );
              })}
            </div>
          );
        } else if (
          questionPresentationContent[question.id]?.component?.type ===
          ComponentType.RADIOANDCHECKBOX
        ) {
          return (
            <div key={question.id}>
              <AssumptionsRadioAndCheckboxQuestion
                question={question}
                handleAssumptionRadioChange={handleChange}
                selectedQuestionsHaveChanged={selectedQuestionsHaveChanged}
                handleCheckboxChange={handleCheckboxChange}
                checkboxState={checkboxState}
              />
            </div>
          );
        } else {
          return (
            <div className="ch-form__group ch-mb--4" key={question.id}>
              <label
                htmlFor={question.id}
                className="ch-form__control-label ch-text--bold"
              >
                {question.content}
              </label>
              <select
                id={question.id}
                name={question.id}
                value={
                  questionHasChanged(question, changedQuestionsKeys)
                    ? selectedQuestionsHaveChanged[question.id]
                    : questionsAndAnswers[question.id]
                }
                className={`ch-form__control ${
                  disabled && "disabled-assumption"
                }`}
                onChange={({ target: { value } }) => {
                  handleChange(question.id, parseInt(value));
                }}
                disabled={disabled}
                data-testid={question.id}
              >
                {sortedAnswers.map((answer) => (
                  <option value={answer.id} key={answer.id}>
                    {answer.label}
                  </option>
                ))}
              </select>
            </div>
          );
        }
      })}
    </div>
  );
}
AssumptionQuestions.propTypes = {
  questions: PropTypes.arrayOf(
    PropTypes.shape({
      answers: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number,
          label: PropTypes.string
        })
      ),
      content: PropTypes.string,
      id: PropTypes.number
    })
  ).isRequired
};
